import { createFileRoute } from "@tanstack/react-router";

import { OrgAiPage } from "../iam/organization/components/OrgAiPage";

/**
 * Route is /organizations/$organizationId/ai: the organization AI co-pilot page,
 * where an owner/admin brings the organization's own AI provider credentials that
 * drive the studio co-pilot. Open to every role — a non-admin sees the masked
 * configuration read-only (the page carries no secret), matching the security and
 * preferences subpages.
 */
export const Route = createFileRoute("/_app/organizations/$organizationId/ai")({
  component: OrgAiPage,
});
